module.exports = __webpack_public_path__ + "img/15pts12.07c43396.png";